import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import { Formik, Form, Field, getIn } from "formik";
import * as yup from "yup";
import { connect } from "react-redux";
import React, { useState } from "react";
import AutoCompleteMultiSelect from "../../components/autoCompleteComponent/AutoCompleteMultiSelect";
import MuiButton from "../../components/muiButton/MuiButton";
import MuiTextField from "../../components/muiTextField/MuiTextField";
import ActivityTypeAction from "../../stores/influencerActivityType/ActivityTypeAction";

// mapstateto props function
const mapDispatchToProps = (dispatch) => {
  return {};
};

// Validation Schema
const validationSchema = yup.object().shape({
  activity_type_name: yup
    .string("Enter Activity Type name")
    .trim()
    .min(1, "Activity Type Name should be of minimum 1 characters length")
    .required("Activity Type Name is required"),

  campaign: yup.object().shape({}).required("Campaign is Required").nullable(),
});

function ActivityTypePost(props) {
  const [loading, setLoading] = useState(false);

  let initial = {};
  if (props.edit) {
    initial = {
      activity_type_name: props.editData.activity_type,
      campaign: props.editData.campaign,
    };
  } else {
    initial = {
      activity_type_name: "",
      campaign: "",
    };
  }

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="sm">
      <Formik
        initialValues={initial}
        validationSchema={validationSchema}
        onSubmit={(values, formikHelpers) => {
          setLoading(true);
          const params = {
            order_by: '[["created_on", "desc"]]',
            page_limit: 15,
          };
          const param = {
            page_limit: "none",
          };
          if (props.edit) {
            props
              .dispatch(
                ActivityTypeAction.requestPutActivityType(
                  JSON.stringify(values),
                  props.editData.id
                )
              )
              .then(() => {
                props.dispatch(ActivityTypeAction.requestActivityType(params));
                props.dispatch(
                  ActivityTypeAction.requestActivityTypeFilter(param)
                );
              });
          } else {
            props
              .dispatch(
                ActivityTypeAction.requestPostActivityType(
                  JSON.stringify(values)
                )
              )
              .then(() => {
                props.dispatch(ActivityTypeAction.requestActivityType(params));
                props.dispatch(
                  ActivityTypeAction.requestActivityTypeFilter(param)
                );
              });
          }
          props.onClose();
          setLoading(false);

          // formikHelpers.resetForm();
        }}
      >
        {({
          errors,
          isValid,
          helperText,
          touched,
          dirty,
          handleChange,
          values,
        }) => (
          <Form>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <DialogContentText sx={{ width: "80%" }}>
                <div className="text-center pb-2">
                  <div className="row p-3">
                    <div className="col-10">
                      <h3 className="dailogtext">
                        {!props.edit ? (
                          <b>
                            <span className="span_first_letter">
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A
                            </span>
                            dd &nbsp;
                            <span className="span_first_letter">A</span>ctivity
                            &nbsp;
                            <span className="span_first_letter">T</span>ype
                          </b>
                        ) : (
                          <b>
                            <span className="span_first_letter">
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;E
                            </span>
                            dit &nbsp;
                            <span className="span_first_letter">A</span>ctivity
                            &nbsp;
                            <span className="span_first_letter">T</span>ype
                          </b>
                        )}
                      </h3>
                    </div>
                    <div className="col-2 closebtn">
                      <i
                        title="Close"
                        className="fa fa-times-circle-o fa-2x"
                        style={{ size: "15px" }}
                        aria-hidden="true"
                        onClick={() => {
                          props.onClose();
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
              </DialogContentText>

              <Grid container>
                <Grid item lg={12} md={12} sm={12} container>
                  <Grid item lg={3} md={3} sm={3} ml={10} mt={1}>
                    Activity Type Name * :
                  </Grid>
                  <Grid item lg={6} md={6} sm={6}>
                    <Field
                      as={MuiTextField}
                      variant="outlined"
                      placeholder="Activity Type"
                      id="activity_type_name"
                      size="small"
                      name="activity_type_name"
                      error={
                        Boolean(errors.activity_type_name) &&
                        Boolean(touched.activity_type_name)
                      }
                      helperText={
                        Boolean(touched.activity_type_name) &&
                        errors.activity_type_name
                      }
                      className="col-10"
                    />
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} container>
                  <Grid item lg={3} md={3} sm={3} ml={10} mt={3}>
                    Campaign * :
                  </Grid>
                  <Grid item lg={5} md={5} sm={5}>
                    <Field
                      name="campaign"
                      size="small"
                      // Calling AutoCompleteMultiSelect Component
                      value={values.campaign ? values.campaign : null}
                      component={AutoCompleteMultiSelect}
                      // disabled={props.edit || values.category}
                      options={props.campaignArray ? props.campaignArray : []}
                      isOptionEqualToValue={(option, value) =>
                        //setting value property to custom value
                        option.campaign_id === value.campaign_id
                      }
                      getOptionLabel={(option) => option.campaign_name}
                      textFieldProps={{
                        margin: "normal",
                        variant: "outlined",
                        placeholder: "Campaign",
                      }}
                      error={
                        Boolean(errors.campaign) && Boolean(touched.campaign)
                      }
                      helperText={Boolean(touched.campaign) && errors.campaign}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions className="m-1 my-4">
              <Grid
                container
                item
                lg={12}
                md={12}
                sm={12}
                display="flex"
                justifyContent="space-evenly"
              >
                <Grid item lg={5} md={5} sm={5} mr={2} minWidth={200}>
                  {!props.edit ? (
                    <MuiButton
                      type="submit"
                      name="Add Activity Type"
                      width="100%"
                      loading={loading}
                    />
                  ) : (
                    <MuiButton
                      type="submit"
                      name="Submit"
                      width="100%"
                      loading={loading}
                    />
                  )}
                </Grid>
                <Grid item lg={5} md={5} sm={5} minWidth={200}>
                  {!props.edit ? (
                    <MuiButton
                      type="reset"
                      name="Reset"
                      onClick={Formik.resetForm}
                      width="100%"
                    />
                  ) : (
                    <MuiButton
                      name={"Cancel"}
                      width="100%"
                      onClick={() => {
                        props.onClose();
                        Formik.resetForm();
                      }}
                    />
                  )}
                </Grid>
              </Grid>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
export default connect(mapDispatchToProps)(ActivityTypePost);
